import FilterModal from "src/components/common/FilterFrame/FilterModal";
import type { FilterFieldConfig } from "src/components/common/FilterFrame/FilterModal";
import { paymentMethodList } from "src/components/common/functions";
import { myOptions } from "src/components/users/UserForm";

import { purchaseCategories } from "./types";

export const fields: FilterFieldConfig[] = [
    { key: "poNumber", label: "PO Number", type: "text", default: "" },
    { key: "poDate", label: "PO Date", type: "range", default: "", inputType: "date" },
    { key: "requesterId", label: "Requester", type: "asyncSelect", default: "", fileName: "common/searchUser.php", placeholder: "Search user…" },
    { key: "projectId", label: "Project", type: "asyncSelect", default: "", fileName: "common/searchProject.php", placeholder: "Search project…" },
    { key: "approverId", label: "Approver", type: "asyncSelect", default: "", fileName: "common/searchUser.php", placeholder: "Search user…" },
    {
        key: "category",
        label: "Category",
        type: "select",
        default: "",
        options: [{ value: "", label: "Select" }, ...purchaseCategories.map(value => ({ value, label: value }))],
    },
    {
        key: "department",
        label: "Department",
        type: "select",
        default: "",
        options: [
            { value: "", label: "Select" },
            ...Object.entries(myOptions.department).flatMap(([group, values]) =>
                (values as string[]).map(value => ({ value, label: `${group} - ${value}` }))
            ),
        ],
    },
    {
        key: "paymentMethod",
        label: "Payment Method",
        type: "select",
        default: "",
        options: [{ value: "", label: "Select" }, ...paymentMethodList.map(value => ({ value, label: value }))],
    },
    { key: "billable", label: "Billable", type: "select", default: "", options: [{ value: "", label: "Select" }, { value: "yes", label: "Yes" }, { value: "no", label: "No" }] },
    { key: "includedInProposal", label: "Included In Proposal", type: "select", default: "", options: [{ value: "", label: "Select" }, { value: "yes", label: "Yes" }, { value: "no", label: "No" }] },
    { key: "status", label: "Status", type: "select", default: "", options: [{ value: "", label: "Select" }, { value: "Submitted", label: "Submitted" }, { value: "Re-Submitted", label: "Re-Submitted" }, { value: "Approved", label: "Approved" }, { value: "Rejected", label: "Rejected" }] },
    { key: "paid", label: "Paid", type: "select", default: "all", options: [{ value: "all", label: "All" }, { value: "yes", label: "Yes" }, { value: "no", label: "No" }] },
    { key: "billed", label: "Billed", type: "select", default: "all", options: [{ value: "all", label: "All" }, { value: "yes", label: "Yes" }, { value: "no", label: "No" }] },
    { key: "total", label: "Total", type: "range", default: "", inputType: "number" },
    { key: "clientInvoiceNumber", label: "Client Invoice Number", type: "text", default: "" },
    { key: "notes", label: "Notes", type: "text", default: "" },
    { key: "creatorId", label: "Creator", type: "asyncSelect", default: "", fileName: "common/searchUser.php", placeholder: "Search user…" },
    { key: "createdAt", label: "Created At", type: "range", default: "", inputType: "date" },
    { key: "updaterId", label: "Updated By", type: "asyncSelect", default: "", fileName: "common/searchUser.php", placeholder: "Search user…" },
    { key: "updatedAt", label: "Updated At", type: "range", default: "", inputType: "date" },
    { key: "void", label: "Validity", type: "select", default: "no", options: [{ value: "no", label: "Valid" }, { value: "yes", label: "Void" }, { value: "all", label: "All" }] },
    { key: "voidReason", label: "Void Reason", type: "text", default: "" },
    { key: "validateReason", label: "Validate Reason", type: "text", default: "" },
];

export default function PurchaseFilterForm() {
    return <FilterModal title = "Filter" width = {650} fields = {fields} />;
}
